module.exports = __webpack_public_path__ + "img/fundRecord.1480b6d7.png";